import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';
import Config from './config';
import RouterAuth from './router_auth';
import Store from './utils/store';

const { Content, Sider } = Layout;

// base component for mount admin layout and app router
export default class AdminLayout extends React.Component {
    static defaultProps = {
        user: {},
    };

    static propTypes = {
        user: PropTypes.instanceOf(Object).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            menuHide: Store.get('menuHide') ? true : false,
        };

        this.changeMenuHideHandle = this.changeMenuHideHandle.bind(this);
    }

    changeMenuHideHandle(menuHide) {
        this.setState({ menuHide });
        Store.set('menuHide', menuHide);
    }

    render() {
        const defaultSelectedKeys = [window.location.pathname];
        return (
            <Layout style={{ minHeight: '100vh', }}>
                <Sider
                    collapsible
                    collapsed={this.state.menuHide}
                    onCollapse={this.changeMenuHideHandle}
                >
                    <div className="logo">
                        <div>
                            <Icon type={"qrcode"} />
                            {this.state.menuHide === false ? (<span>RT QR</span>) : (<span>RT</span>)}
                        </div>
                    </div>
                    <Menu theme={"dark"} defaultSelectedKeys={defaultSelectedKeys}>
                        {Config.MENU.map(i => {
                            return (
                                <Menu.Item key={`${i.path}`}>
                                    <Link to={i.path}>
                                        <Icon type={i.icon} />
                                        <span>{i.title}</span>
                                    </Link>
                                </Menu.Item>
                            );
                        })}
                    </Menu>
                </Sider>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <div style={{ width: '100%', backgroundColor: '#FFF', marginTop: 12, padding: 12, borderRadius: 4 }} >
                        <RouterAuth user={this.user}/>
                    </div>
                </Content>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/AdminLayout.js